import React from "react";
import { Col, FormControl, FormGroup, FormLabel } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { ErrorField } from "../../../../extras/EditExtra/styles";
import { extraCategoryInputsMessages as messages } from "./ExtraCategoryInputs.messages";
import { HelpText } from "./ExtraCategoryInputs.styles";
import { NO_VEHICLE_TYPE } from "./extraCategoryInputs.viewModel";
import { useExtraCategoryInputs } from "./useExtraCategoryInputs";

interface ExtraCategoryFieldsProps {
  disabled: boolean;
}

/** Category, then Vehicle type and the licence plate checkbox for a Vehicle extra. */
export function ExtraCategoryFields({ disabled }: ExtraCategoryFieldsProps) {
  const { category, vehicleType, requestLicensePlate } = useExtraCategoryInputs(disabled);

  return (
    <>
      <FormGroup as={Col}>
        <FormLabel column sm={12} htmlFor={category.id}>
          <FormattedMessage {...messages.category} />
        </FormLabel>
        <Col sm={3}>
          <FormControl
            as="select"
            id={category.id}
            name={category.name}
            ref={category.inputRef}
            value={category.value}
            disabled={category.disabled}
            aria-describedby={category.showUnsupportedHelp ? `${category.id}Help` : undefined}
            onChange={event => category.onChange(event.target.value)}
            onBlur={category.onBlur}>
            {category.options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </FormControl>
          {category.showUnsupportedHelp && (
            <HelpText id={`${category.id}Help`}>
              <FormattedMessage {...messages.categoryUnsupportedHelp} />
            </HelpText>
          )}
          {category.error && <ErrorField role="alert">{category.error}</ErrorField>}
        </Col>
      </FormGroup>

      {vehicleType && (
        <FormGroup as={Col}>
          <FormLabel column sm={12} htmlFor={vehicleType.id}>
            <FormattedMessage {...messages.vehicleType} /> {"*"}
          </FormLabel>
          <Col sm={3}>
            <FormControl
              as="select"
              id={vehicleType.id}
              name={vehicleType.name}
              ref={vehicleType.inputRef}
              value={vehicleType.value}
              disabled={vehicleType.disabled}
              required
              isInvalid={Boolean(vehicleType.error)}
              onChange={event => vehicleType.onChange(event.target.value)}
              onBlur={vehicleType.onBlur}>
              <option value={NO_VEHICLE_TYPE}>{vehicleType.placeholder}</option>
              {vehicleType.options.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </FormControl>
            {vehicleType.error && <ErrorField role="alert">{vehicleType.error}</ErrorField>}
          </Col>
        </FormGroup>
      )}

      {requestLicensePlate && (
        <FormGroup as={Col}>
          <Col sm={12}>
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input !mt-[3px]"
                id={requestLicensePlate.id}
                name={requestLicensePlate.name}
                ref={requestLicensePlate.inputRef}
                checked={requestLicensePlate.checked}
                disabled={requestLicensePlate.disabled}
                onChange={event => requestLicensePlate.onChange(event.target.checked)}
                onBlur={requestLicensePlate.onBlur}
              />
              <label className="form-check-label" htmlFor={requestLicensePlate.id}>
                <FormattedMessage {...messages.requestLicensePlate} />
              </label>
            </div>
            {requestLicensePlate.error && (
              <ErrorField role="alert">{requestLicensePlate.error}</ErrorField>
            )}
          </Col>
        </FormGroup>
      )}
    </>
  );
}
